import React from "react";
import "./style.css"

export default function MainTitle({text}){
    return (
        <p className="main-title">{text}</p>
    );
}